import { Style } from "@portal/lib/style/style";
import { Select } from "../Select/AntSelect";

export const StyledInvoiceSearch = Style(Select<string[]>, {
  width: "100%",
  ".ant-select-selector": {
    height: "32px",
    border: "1px solid var(--gray-5) !important",
  },
});
